module.exports = __webpack_public_path__ + "img/1027120191.4b9552be.jpg";